import { Component, OnDestroy, OnInit } from "@angular/core";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { ModelStudentprofile } from "../../model/model.studentprofile";
import { empty } from "../../functions";
import { LocaleService } from "../../shared/services/locale.service";
import { ValidationService } from "../../shared/services/validation.service";
import {
  faCheckCircle,
  faGraduationCap,
  faPlus,
  faTimes,
  faBriefcase,
  faGlobe,
  faPlane,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { UserService } from "../../shared/services/user.service";
import { catchError } from "rxjs/operators";
import { Observable, of, pipe, Subscription } from "rxjs";
import { ModalService } from "../../shared/services/modal.service";
import { RoleTypes } from "../../guards/roletypes";
import { ApiService } from "../../shared/services/api.service";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { StudentService } from "../../shared/services/student.service";
import { EducationService } from "../../shared/services/education.service";
import { InterestService } from "../../shared/services/interest.service";
import {
  ProfileTypeUtils,
  ProfileLookingForUtils,
  LanguageProficiencyUtils,
} from "../../shared/utils/student-profile.utils";
import { Router } from "@angular/router";
import { longMinDate } from "../../shared/services/time.service";
import { DomainService } from "../../shared/services/domain.service";
import { GlobalService } from "../../shared/services/global.service";
import { StudentProfileService } from "../../api/services/student-profile.service";
import { StudentProfile } from "../../api/models/student-profile";
import { ModalStudentProfileWorkexperienceComponent } from "../student-profile/modal-student-profile-workexperience/modal-student-profile-workexperience.component";
import { ModalStudentProfileLanguageComponent } from "../student-profile/modal-student-profile-language/modal-student-profile-language.component";
import { ModalStudentProfileForeignexperienceComponent } from "../student-profile/modal-student-profile-foreignexperience/modal-student-profile-foreignexperience.component";
import { ModalStudentProfileHobbyComponent } from "../student-profile/modal-student-profile-hobby/modal-student-profile-hobby.component";
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { CvUploadImportResult } from '../../shared/components/formly-fields';

@Component({
  selector: "app-student-registration",
  templateUrl: "./student-registration.component.html",
  styleUrls: ["./student-registration.component.scss"],
  standalone: false,
})
export class StudentRegistrationComponent implements OnInit, OnDestroy {
  maxAmount = this.studentService.maxAmountAreaOfInterests;

  longMinDate = longMinDate;

  faGraduationCap = faGraduationCap;
  faCheckCircle = faCheckCircle;
  faPlus = faPlus;
  faTimes = faTimes;
  faBriefcase = faBriefcase;
  faGlobe = faGlobe;
  faPlane = faPlane;
  faStar = faStar;

  /**
   * Student profile entity data
   */
  public entity: any | ModelStudentprofile = {
    id: "",
    firstName: "",
    lastName: "",
    infix: "",
    homeAddress: {
      street: "",
      number: "",
      numberSuffix: "",
      postalCode: "",
      city: "",
      country: "",
    },
    phoneNumber: "",
    birthDate: "",
    parentEmailAddress: "",
    hasParentalConsent: false,
    profileType: "",
    lookingFor: "",
    allowEmailNotifications: true,
    isSubscribedToNewsletter: true,
    hasMediaConsent: false,
    hasAcceptedGdprPolicy: false,
    hasDataUsageConsent: false,
    areaOfInterests: [],
    referenceCode: "",
    preferredLanguage: "",
  };

  education = {
    schoolId: null,
    educationLevelId: null,
    educationProfileId: null,
    educationProgramId: null,
    schoolName: "",
    schoolCity: "",
    schoolCountry: "",
    programName: "",
    level: "",
    profile: "",
    phase: "",
    description: "",
    extras: "",
    education: "",
    startDate: null,
    endDate: null,
    isCurrent: false,
    graduated: false,
    areaOfInterests: <any>[],
  };

  // CV-stap state — populated when entering step 3 from Task 4 onwards
  cv = {
    workExperiences: [] as any[],
    languages: [] as any[],
    foreignExperiences: [] as any[],
    hobbies: [] as any[],
  };

  // CV upload + AI import (shared Formly field)
  cvUploadForm = new FormGroup({});
  cvUploadModel: Record<string, unknown> = {};
  cvUploadFields: FormlyFieldConfig[] = [];
  cvImport = {
    completed: false,
    importedCounts: { workExperience: 0, languages: 0 },
  };

  private profileId: string = '';

  showParentalConsent = false;

  /**
   * Wizard with steps
   */
  public stepWizard = {
    currentStep: <number>1,
    steps: <any>[
      {
        step: 1,
        title: "Personal details",
        validation: {
          validated: false,
          fields: {
            entity: {
              firstName: {
                regex: "required",
                error: false,
              },
              lastName: {
                regex: "required",
                error: false,
              },
              birthDate: {
                regex: "required",
                error: false,
              },
              phoneNumber: {
                regex: "required",
                error: false,
              },
              profileType: {
                regex: "required",
                error: false,
              },
              lookingFor: {
                regex: "required",
                error: false,
              },
              homeAddress: {
                street: {
                  regex: "required",
                  error: false,
                },
                number: {
                  regex: "required",
                  error: false,
                },
                postalCode: {
                  regex: "required",
                  error: false,
                },
                city: {
                  regex: "required",
                  error: false,
                },
                country: {
                  regex: "required",
                  error: false,
                },
              },
            },
          },
        },
      },
      {
        step: 2,
        title: "Education",
        validation: {
          validated: false,
          fields: {
            education: {
              startDate: {
                regex: "required",
                error: false,
              },
              educationLevelId: {
                regex: "required",
                error: false,
              },
            },
          },
        },
      },
      {
        step: 3,
        title: "CV",
      },
      {
        step: 4,
        title: "Match",
      },
    ],
  };

  /**
   * Options for the student to define type of user
   */
  profileTypeOptions: any[] = [];

  lookingForOptions: any = [];

  // Education
  areaOfInterests: any = [];
  educationlevelSubscription: Subscription = new Subscription();

  public educationLevels: any = [];
  public profileOptions: any = [];
  public phaseOptions: any = [];

  supportedLanguages = this.localeService.supportedLanguages;

  /**
   * Constructor
   *
   * @param global
   * @param localeService
   * @param api
   * @param authService
   * @param modal
   * @param locale
   * @param validationService
   * @param userService
   * @param modalService
   * @param studentService
   * @param educationService
   * @param interestService
   * @param router
   * @param domain
   */
  constructor(
    public global: GlobalService,
    public localeService: LocaleService,
    private api: ApiService,
    private authService: AuthenticationService,
    public modal: ModalService,
    public locale: LocaleService,
    private validationService: ValidationService,
    private userService: UserService,
    public modalService: ModalService,
    private studentService: StudentService,
    public educationService: EducationService,
    public interestService: InterestService,
    public router: Router,
    public domain: DomainService,
    private studentProfileService: StudentProfileService
  ) {}

  /**
   * Ng on init
   */
  ngOnInit(): void {
    this.profileTypeOptions = ProfileTypeUtils.getOptions();
    this.lookingForOptions = ProfileLookingForUtils.getOptions();

    // Fetch education levels
    this.educationlevelSubscription = this.educationService
      .apiGetEducationLevels(this.domain.getCurrentRegion())
      .subscribe((result: any) => {
        if (result) {
          this.educationLevels = result.data;
        }

        this.setEducationLevelOptions();
      });

    this.interestService.apiGetAreaOfInterests().subscribe((result: any) => {
      this.areaOfInterests = result.data;
    });
  }

  /**
   * Ng on destroy
   */
  ngOnDestroy() {
    this.educationlevelSubscription.unsubscribe();
  }

  /**
   * Show validation error
   *
   * Determine if a validation error needs to be visible to client
   *
   * @param stepNumber
   * @param $entity
   * @param $entityProperty
   */
  showValidationError(
    stepNumber: number,
    $entity: string,
    $entityProperty: string,
    $entitySub: string = ""
  ) {
    const index = stepNumber - 1;

    if ($entitySub) {
      if (
        !this.stepWizard.steps[index]["validation"]["fields"][$entity][
          $entitySub
        ].hasOwnProperty($entityProperty)
      ) {
        return false;
      }

      if (
        this.stepWizard.steps[index]["validation"]["validated"] &&
        this.stepWizard.steps[index]["validation"]["fields"][$entity][
          $entitySub
        ][$entityProperty]["error"] === true
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        !this.stepWizard.steps[index]["validation"]["fields"][
          $entity
        ].hasOwnProperty($entityProperty)
      ) {
        return false;
      }

      if (
        this.stepWizard.steps[index]["validation"]["validated"] &&
        this.stepWizard.steps[index]["validation"]["fields"][$entity][
          $entityProperty
        ]["error"] === true
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  /**
   * Check age and toggle parental consent options
   */
  checkAge() {
    if (this.entity.birthDate) {
      const birthDate = new Date(this.entity.birthDate);
      const ageDifMs = Date.now() - birthDate.getTime();
      const ageDate = new Date(ageDifMs); // miliseconds from epoch
      const age = Math.abs(ageDate.getUTCFullYear() - 1970);

      // Show or hide parental consent and add / remove validation on step 1 for parent consent
      if (age < 16) {
        this.showParentalConsent = true;
        this.stepWizard.steps[0]["validation"]["fields"]["entity"][
          "hasParentalConsent"
        ] = {
          regex: "true",
          error: false,
        };
        this.stepWizard.steps[0]["validation"]["fields"]["entity"][
          "parentEmailAddress"
        ] = {
          regex: "email",
          error: false,
        };
      } else {
        this.showParentalConsent = false;
        if (
          this.stepWizard.steps[0]["validation"]["fields"][
            "entity"
          ].hasOwnProperty("hasParentalConsent")
        ) {
          delete this.stepWizard.steps[0]["validation"]["fields"]["entity"][
            "hasParentalConsent"
          ];
        }
        if (
          this.stepWizard.steps[0]["validation"]["fields"][
            "entity"
          ].hasOwnProperty("parentEmailAddress")
        ) {
          delete this.stepWizard.steps[0]["validation"]["fields"]["entity"][
            "parentEmailAddress"
          ];
        }
      }
    }
  }

  /**
   * Go to next step and validate
   */
  nextStep() {
    const totalSteps = this.stepWizard.steps.length;

    if (this.stepWizard.currentStep < totalSteps) {
      const valid = this.validateWizard(this.stepWizard.currentStep);
      if (valid) {
        // Check step to process data
        switch (this.stepWizard.currentStep) {
          case 1:
            // Normal procedure
            this.stepWizard.currentStep++;
            // Scroll back to top automatically when route is activated
            window.scrollTo(0, 0);
            break;

          case 2:
            // Save profile to go to last step
            this.handleStep2();
            break;

          case 3:
            // CV-step — Next behaves like Skip; advance to Match without confirm
            this.stepWizard.currentStep++;
            window.scrollTo(0, 0);
            break;
        }
      }
    } else {
      const valid = this.validateWizard();
      this.stepWizard.currentStep++;
    }
  }

  /**
   * Go to previous step and validate
   */
  previousStep() {
    if (this.stepWizard.currentStep > 1) this.stepWizard.currentStep--;
  }

  /**
   * Validate wizard step(s)
   */
  validateWizard($step: any = null) {
    let valid = true;
    const self: any = this;

    if (this.stepWizard.steps.length > 0) {
      for (const s in this.stepWizard.steps) {
        // Only validate based on step number
        if (!empty($step) && $step !== this.stepWizard.steps[s]["step"])
          continue;

        let stepValid = true;

        if (
          !empty(this.stepWizard.steps[s].validation) &&
          this.stepWizard.steps[s]["validation"].hasOwnProperty("fields")
        ) {
          // Set entity data selectors
          const $entitySelectors = [
            "entity",
            "education",
            "entity.homeAddress",
          ];

          // Check entity columns
          for (const $entitySelector of $entitySelectors) {
            const $entitySplit = $entitySelector.split(".");

            if ($entitySplit.length > 1) {
              const $entitySelectorMain = $entitySplit[0];
              const $entitySelectorSub = $entitySplit[1];

              if (
                this.stepWizard.steps[s]["validation"]["fields"].hasOwnProperty(
                  $entitySelectorMain
                ) &&
                this.stepWizard.steps[s]["validation"]["fields"][
                  $entitySelectorMain
                ].hasOwnProperty($entitySelectorSub)
              ) {
                for (const key in this.stepWizard.steps[s]["validation"][
                  "fields"
                ][$entitySelectorMain][$entitySelectorSub]) {
                  if (
                    !empty(
                      this.stepWizard.steps[s]["validation"]["fields"][
                        $entitySelectorMain
                      ][$entitySelectorSub][key]
                    )
                  ) {
                    const entity =
                      this.stepWizard.steps[s]["validation"]["fields"][
                        $entitySelectorMain
                      ][$entitySelectorSub][key];

                    if (entity.hasOwnProperty("regex")) {
                      const value =
                        self[$entitySelectorMain][$entitySelectorSub][key];
                      const regPattern = entity["regex"];

                      // Set validation flags
                      if (
                        !this.validationService.regexValidation(
                          regPattern,
                          value
                        )
                      ) {
                        this.stepWizard.steps[s]["validation"]["fields"][
                          $entitySelectorMain
                        ][$entitySelectorSub][key]["error"] = true;

                        stepValid = false;
                        valid = false;
                      } else {
                        this.stepWizard.steps[s]["validation"]["fields"][
                          $entitySelectorMain
                        ][$entitySelectorSub][key]["error"] = false;
                      }
                    }
                  }
                }
              }
            } else {
              if (
                this.stepWizard.steps[s]["validation"]["fields"].hasOwnProperty(
                  $entitySelector
                )
              ) {
                for (const key in this.stepWizard.steps[s]["validation"][
                  "fields"
                ][$entitySelector]) {
                  if (
                    !empty(
                      this.stepWizard.steps[s]["validation"]["fields"][
                        $entitySelector
                      ][key]
                    )
                  ) {
                    const entity =
                      this.stepWizard.steps[s]["validation"]["fields"][
                        $entitySelector
                      ][key];

                    if (entity.hasOwnProperty("regex")) {
                      const value = self[$entitySelector][key];
                      const regPattern = entity["regex"];

                      // Set validation flags
                      if (
                        !this.validationService.regexValidation(
                          regPattern,
                          value
                        )
                      ) {
                        this.stepWizard.steps[s]["validation"]["fields"][
                          $entitySelector
                        ][key]["error"] = true;

                        stepValid = false;
                        valid = false;
                      } else {
                        this.stepWizard.steps[s]["validation"]["fields"][
                          $entitySelector
                        ][key]["error"] = false;
                      }
                    }
                  }
                }
              }
            }
          }

          // Set validation flags for step
          this.stepWizard.steps[s]["validation"]["valid"] = stepValid;
          this.stepWizard.steps[s]["validation"]["validated"] = true;
        }

        if (!empty($step)) return stepValid;
      }
    }

    const validationErrors = this.getValidationErrorCount($step);

    if (validationErrors > 0) {
      valid = false;

      this.navigationAfterValidation();
    } else {
      valid = true;
    }

    return valid;
  }

  /**
   * Count the invalid steps of validation
   */
  getValidationErrorCount($step = null) {
    let counter = 0;
    for (const s in this.stepWizard.steps) {
      // Only validate based on step number
      if (!empty($step) && $step !== this.stepWizard.steps[s]["step"]) continue;

      if (this.stepWizard.steps[s]["validation"]["valid"] === false) counter++;
    }
    return counter;
  }

  /**
   * Navigate to a step where a validation error occurred
   */
  navigationAfterValidation() {
    for (const s in this.stepWizard.steps) {
      if (this.stepWizard.steps[s]["validation"]["valid"] === false) {
        this.stepWizard.currentStep = this.stepWizard.steps[s]["step"];
        return true;
      }
    }

    return false;
  }

  /**
   * Handle step 2
   *
   * Create / update studentprofile and proceed with step
   * @constructor
   */
  handleStep2() {
    const targetGroup = this.authService.getRegistrationTargetGroup() ?? "Mty";
    const accountParams: any = {
      accountType: RoleTypes.Student,
      targetGroups: [targetGroup],
    };

    // Step 2: create account and student profile directly
    const studentprofileParams = {
      firstName: this.entity.firstName,
      lastName: this.entity.lastName,
      infix: this.entity.infix,
      birthDate:
        this.entity["birthDate"] instanceof Date
          ? this.entity["birthDate"].toISOString()
          : new Date().toISOString(),
      homeAddress: {
        street: this.entity.homeAddress.street,
        number: this.entity.homeAddress.number,
        numberSuffix: this.entity.homeAddress.numberSuffix,
        city: this.entity.homeAddress.city,
        postalCode: this.entity.homeAddress.postalCode,
        country: this.entity.homeAddress.country,
      },
      phoneNumber: this.entity.phoneNumber,
      parentEmailAddress: this.entity.parentEmailAddress,
      hasParentalConsent: this.entity.hasParentalConsent,
      profileType: this.entity.profileType,
      lookingFor: this.entity.lookingFor,
      isSubscribedToNewsletter: true,
      allowEmailNotifications: true,
      referenceCode: this.entity.referenceCode,
      preferredLanguage: this.locale.getCurrentLanguage(),
    };

    // Check current account first
    this.userService
      .apiGetAccountCurrent()
      .pipe(catchError(this.handleError("apiGetAccountCurrent", null)))
      .subscribe((account) => {
        if (!empty(account)) {
          this.authService.setProfileData(account);

          // Check if we need to create a student profile or update
          this.studentProfileService
            .getCurrentStudentProfile()
            .pipe(
              catchError(this.handleError("apiGetStudentprofileCurrent", null))
            )
            .subscribe((studentprofileCurrent) => {
              // Update the profile
              if (!empty(studentprofileCurrent)) {
                this.handleMaybeRedirectAfterRegistration();
                this.captureProfileIdAndLoadCv();
              } else {
                this.modal.Loader(true);

                this.studentProfileService
                  .registerStudentProfile({ body: studentprofileParams })
                  .pipe(
                    catchError(
                      this.handleError("apiRegisterStudentprofile", false)
                    )
                  )
                  .subscribe((response) => {
                    this.modal.Loader(false);

                    if (response !== false) {
                      this.updateStudentprofileAfterRegistration();
                      this.handleMaybeRedirectAfterRegistration();
                      this.captureProfileIdAndLoadCv();
                    } else {
                      this.modal.Alert(
                        "Error",
                        "Something went wrong, please try again"
                      );
                    }
                  });
              }
            });
        } else {
          // Create account and student profile

          // Step 1: create account

          this.userService
            .apiAccountRegister(accountParams, "Student")
            .pipe(catchError(this.handleError("apiAccountRegister", null)))
            .subscribe((accountResponse) => {
              // If account is created, create student profile
              if (!empty(accountResponse)) {
                this.authService.setProfileData(accountResponse);
                this.authService.clearRegistrationTargetGroup();

                this.modal.Loader(true);

                this.studentProfileService
                  .registerStudentProfile({ body: studentprofileParams })
                  .pipe(
                    catchError(
                      this.handleError("apiRegisterStudentprofile", false)
                    )
                  )
                  .subscribe((response) => {
                    this.modal.Loader(false);

                    if (response !== false) {
                      this.updateStudentprofileAfterRegistration();
                      this.handleMaybeRedirectAfterRegistration();
                      this.captureProfileIdAndLoadCv();
                    } else {
                      this.modal.Alert(
                        "Error",
                        "Something went wrong, please try again"
                      );
                    }
                  });
              } else {
                this.modal.Alert(
                  "Register",
                  "Something went wrong, please try again"
                );
              }
            });
        }
      });
  }

  /**
   * Update extra data after student registration
   */
  updateStudentprofileAfterRegistration() {
    this.studentProfileService
      .getCurrentStudentProfile()
      .pipe(catchError(this.handleError("getCurrentStudentProfile", false)))
      .subscribe((result: any) => {
        if (result !== false) {
          // Update remain data like area of interest and education

          if (!empty(result.id)) {
            // Update extra profile data which is not in register endpoint
            const profile = result;
            profile.lookingFor = this.entity.lookingFor;
            profile.profileType = this.entity.profileType;

            // Update student profile with additional fields
            this.studentProfileService
              .updateStudentProfile({
                id: result.id,
                body: profile as StudentProfile,
              })
              .pipe(
                catchError(
                  this.studentService.handleError(
                    "apiUpdateStudentprofile",
                    false
                  )
                )
              )
              .subscribe(() => {
                // Add the area of interests to the students profile
                this.studentService
                  .apiUpdateAreaofinterests(
                    result.id,
                    this.entity.areaOfInterests
                  )
                  .pipe(
                    catchError(
                      this.handleError("apiUpdateAreaofinterests", false)
                    )
                  )
                  .subscribe((result) => {});

                // Add area of interests to the education as well
                this.education.areaOfInterests = Object.assign(
                  [],
                  this.entity.areaOfInterests
                );

                // Add the education to the students profile
                this.studentService
                  .apiAddEducation(result.id, this.education)
                  .pipe(catchError(this.handleError("apiAddEducation", false)))
                  .subscribe(() => {});
              });
          }
        }
      });
  }

  /**
   * Set available options for selected education level
   */
  setEducationLevelOptions() {
    if (this.education.educationLevelId) {
      for (const i in this.educationLevels) {
        if (this.educationLevels.hasOwnProperty(i)) {
          const educationlevel = this.educationLevels[i];

          if (educationlevel["id"] == this.education.educationLevelId) {
            if (educationlevel.hasOwnProperty("educationProfiles")) {
              this.profileOptions = educationlevel.educationProfiles;
            } else {
              this.profileOptions = [];
            }
            if (educationlevel.hasOwnProperty("phases")) {
              this.phaseOptions = educationlevel.phases;
            } else {
              this.phaseOptions = [];
            }
          }
        }
      }
    }
  }

  /**
   * Event handler for education program typeahead selection
   *
   * @param $event
   */
  handleEducationProgramSelection($event: any) {
    if ($event.hasOwnProperty("data")) {
      const educationProgramData = Object.assign({}, $event["data"]);

      // Map data

      // Set education program data
      if (
        educationProgramData.hasOwnProperty("id") &&
        educationProgramData.id !== null
      ) {
        this.education.educationProgramId = educationProgramData.id;
      }
      if (
        educationProgramData.hasOwnProperty("title") &&
        educationProgramData.title !== null
      ) {
        this.education.programName = educationProgramData.title;
      }

      // Set education level data
      if (
        educationProgramData.hasOwnProperty("educationLevel") &&
        educationProgramData.educationLevel !== null
      ) {
        this.education.educationLevelId =
          educationProgramData.educationLevel.id;
      }

      // Set school data
      if (
        educationProgramData.hasOwnProperty("school") &&
        educationProgramData.school !== null
      ) {
        this.education.schoolName = educationProgramData.school.name;
        this.education.schoolCity = educationProgramData.school.address.city;
        this.education.schoolCountry =
          educationProgramData.school.address.country;
      }
    }
  }

  /**
   * Match redirects student to student companies page to show a modal with first matches
   *
   * Uses a query param to identify whether to show a modal or not
   *
   * @constructor
   */
  Match() {
    // TMP: navigate to profile
    this.router.navigate(["/student/companies"], {
      queryParams: { showMatches: true },
    });
  }

  private buildCvUploadField(): void {
    this.cvUploadFields = [
      {
        key: 'cv',
        type: 'cv-upload-import',
        props: {
          profileId: this.profileId,
          onComplete: (r: CvUploadImportResult) => this.onCvUploadComplete(r),
        },
      },
    ];
  }

  private onCvUploadComplete(r: CvUploadImportResult): void {
    if (r.imported && r.profile) {
      const beforeWork = this.cv.workExperiences.length;
      const beforeLang = this.cv.languages.length;
      const work = (r.profile as any).workExperiences ?? [];
      const lang = (r.profile as any).languageProficiencies ?? [];
      this.cvImport.importedCounts = {
        workExperience: Math.max(0, work.length - beforeWork),
        languages: Math.max(0, lang.length - beforeLang),
      };
      this.cvImport.completed = true;
    }
    this.refreshCvFromProfile();
  }

  /**
   * Refresh CV-state from the latest profile data
   */
  private refreshCvFromProfile(): void {
    if (!this.profileId) return;

    this.studentProfileService
      .getCurrentStudentProfile()
      .pipe(catchError(this.handleError('getCurrentStudentProfile', null)))
      .subscribe((profile: any) => {
        if (!profile) return;
        this.cv.workExperiences = profile.workExperiences ?? [];
        this.cv.languages = profile.languageProficiencies ?? [];
        this.cv.foreignExperiences = profile.foreignExperiences ?? [];
        this.cv.hobbies = profile.interests ?? [];
      });
  }

  /**
   * Fetch the just-created profile, cache its id, and seed the CV lists.
   */
  private captureProfileIdAndLoadCv(): void {
    this.studentProfileService
      .getCurrentStudentProfile()
      .pipe(catchError(this.handleError('getCurrentStudentProfile', null)))
      .subscribe((profile: any) => {
        if (!profile?.id) {
          this.modal.Alert(marker('Error'), marker('Could not load profile. Returning to match.'));
          this.stepWizard.currentStep = 4;
          return;
        }
        this.profileId = profile.id;
        this.buildCvUploadField();
        this.cv.workExperiences = profile.workExperiences ?? [];
        this.cv.languages = profile.languageProficiencies ?? [];
        this.cv.foreignExperiences = profile.foreignExperiences ?? [];
        this.cv.hobbies = profile.interests ?? [];
        this.stepWizard.currentStep = 3;
        window.scrollTo(0, 0);
      });
  }

  openWorkExperienceModal(): void {
    if (!this.profileId) return;

    const modalOptions = { backdrop: 'static' as const, size: 'lg' };
    const data = { profile_id: this.profileId, workExperience: {} };

    this.modal.Modal(ModalStudentProfileWorkexperienceComponent, '', '', data, [], modalOptions)
      .then((result) => {
        if (result === true) this.refreshCvFromProfile();
      })
      .catch(() => {});
  }

  openLanguageModal(): void {
    if (!this.profileId) return;

    const modalOptions = { backdrop: 'static' as const, size: 'lg' };
    const data = {
      profile_id: this.profileId,
      languageProficiency: {
        id: '',
        languageCode: '',
        speakingProficiency: 0,
        readingProficiency: 0,
        writingProficiency: 0,
      },
    };

    this.modal.Modal(ModalStudentProfileLanguageComponent, '', '', data, [], modalOptions)
      .then((result) => {
        if (result === true) this.refreshCvFromProfile();
      })
      .catch(() => {});
  }

  openForeignExperienceModal(): void {
    if (!this.profileId) return;

    const modalOptions = { backdrop: 'static' as const, size: 'lg' };
    const data = { profile_id: this.profileId, foreignExperience: {} };

    this.modal.Modal(ModalStudentProfileForeignexperienceComponent, '', '', data, [], modalOptions)
      .then((result) => {
        if (result === true) this.refreshCvFromProfile();
      })
      .catch(() => {});
  }

  openHobbyModal(): void {
    if (!this.profileId) return;

    const modalOptions = { backdrop: 'static' as const, size: 'lg' };
    const data = {
      profile_id: this.profileId,
      interest: { id: '', description: '' },
    };

    this.modal.Modal(ModalStudentProfileHobbyComponent, '', '', data, [], modalOptions)
      .then((result) => {
        if (result === true) this.refreshCvFromProfile();
      })
      .catch(() => {});
  }

  removeWorkExperience(id: string): void {
    if (!this.profileId || !id) return;

    this.studentService.apiDeleteWorkExperience(this.profileId, id)
      .pipe(catchError(this.handleError('apiDeleteWorkExperience', false)))
      .subscribe(() => this.refreshCvFromProfile());
  }

  removeLanguage(id: string): void {
    if (!this.profileId || !id) return;

    this.studentService.apiDeleteLanguageProficiency(this.profileId, id)
      .pipe(catchError(this.handleError('apiDeleteLanguageProficiency', false)))
      .subscribe(() => this.refreshCvFromProfile());
  }

  removeForeignExperience(id: string): void {
    if (!this.profileId || !id) return;

    this.studentService.apiDeleteForeignExperience(this.profileId, id)
      .pipe(catchError(this.handleError('apiDeleteForeignExperience', false)))
      .subscribe(() => this.refreshCvFromProfile());
  }

  removeHobby(id: string): void {
    if (!this.profileId || !id) return;

    this.studentService.apiDeleteInterest(this.profileId, id)
      .pipe(catchError(this.handleError('apiDeleteInterest', false)))
      .subscribe(() => this.refreshCvFromProfile());
  }

  getLanguageLevelName(value: number): string {
    return LanguageProficiencyUtils.getLevelName(value);
  }

  skipCvStep(): void {
    this.modal.Confirm(
      marker('Skip CV'),
      marker('A complete CV gives you more matches. Skip anyway?'),
      {},
      [],
      {},
      false
    ).then((confirmed) => {
      if (confirmed === true) {
        this.stepWizard.currentStep = 4;
        window.scrollTo(0, 0);
      }
    }).catch(() => {});
  }

  /**
   * Error handler
   *
   * @param operation
   * @param result
   */
  handleError<T>(operation: string = "", result?: T) {
    return (error: any): Observable<T> => {
      // Handle given operation
      switch (operation) {
        case "apiGetAccountCurrent":
        case "apiGetStudentprofileCurrent":
        case "apiRegisterStudentprofile":
          // Do not perform any action, profile could be non-existing
          break;

        default:
          // this.modalService.Alert('Error', 'Something went wrong, please try again');
          break;
      }

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  handleMaybeRedirectAfterRegistration(): void {
    if (this.authService.getRedirectUrlAfterRegistration()) {
      const redirectUrlAfterRegistration =
        this.authService.getRedirectUrlAfterRegistration();
      window.localStorage.removeItem(
        this.authService.localStorageRedirectAfterRegistrationKey
      );

      if (typeof redirectUrlAfterRegistration === "string") {
        window.location.replace(redirectUrlAfterRegistration);
      }
    }
  }
}
